import { HTTP } from "./http";

let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-games.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-games.php";
}

const TrainingWeek = {
  getWeekData(params) {
    return HTTP.post(API_SERVER, { action: "getTrainingWeekData", ...params });
  },

  getMatchDay(params) {
    return HTTP.post(API_SERVER, { action: "getMatchDayForWeek", ...params });
  },

  saveSessionDrills(params) {
    return HTTP.post(API_SERVER, { action: "saveSessionDrills", ...params });
  },

  getSessionDrills(gameId) {
    return HTTP.post(API_SERVER, { action: "getSessionDrills", gameId });
  },

  savePerformanceReport(params) {
    return HTTP.post(API_SERVER, { action: "saveTrainingPerformanceReportV2", ...params });
  },

  savePlayerOwnSession(params) {
    return HTTP.post(API_SERVER, { action: "savePlayerOwnSession", ...params });
  },

  getSeasonStats(params) {
    return HTTP.post(API_SERVER, { action: "getSeasonTrainingStats", ...params });
  },

  setAttendance(params) {
    return HTTP.post(API_SERVER, { action: "setUserGameResponse", ...params });
  },
};

export { TrainingWeek };
